import Drawer from 'components/Drawer/Drawer';
import ScriptSnippet from 'components/ScriptSnippet';
import useWidgetGenerate from 'hooks/useWidgetGenerate';
import { FC } from 'react';
import CustomizeScheduleButton from '../WidgetSection/CustomizeScheduleButton/CustomizeScheduleButton';
import useClinic from 'hooks/useClinic';

interface ScriptDrawerProps {
  isShowing: boolean;
  setIsShowing: React.Dispatch<React.SetStateAction<boolean>>;
}

const ScriptDrawer: FC<ScriptDrawerProps> = ({ isShowing, setIsShowing }) => {
  const { data, isLoading } = useWidgetGenerate();

  const { data: clinicData, isLoading: isClinicLoading } = useClinic();

  const isAllLoading = isLoading || isClinicLoading;

  const isAppleTreeDental =
    clinicData?.id === 'CL_5Q0NF4jbhm4Lb3_AAo2RD' ||
    clinicData?.id === 'CL_TFfSdMw8GeFUb-Bjlh5Sh';

  const isSageDental =
    clinicData?.id === 'CL_D45PfllQcfroogl-t2EK-' ||
    clinicData?.id === 'CL_YDrPIi0fl6NWkw9DjZN0z';

  const isOneDental =
    clinicData?.id === 'CL_6tZH_Cyx_GcL2EehKlThF' ||
    clinicData?.id === 'CL_CvxRbS50_WcjpA1lBq27n' ||
    clinicData?.id === 'CL_5Fu3GaF0aDAZDHZsgSB29';

  const isSerenityDental =
    clinicData?.id === 'CL_xdxyRQiIJfyRJUIHWHNgT' ||
    clinicData?.id === 'CL_eyaRqiPseUGKKOZcJu_rN';

  const isSmileMasDental =
    clinicData?.id === 'CL_t7SbABB4BwtkSDpCRIL0m' ||
    clinicData?.id === 'CL_KQtzLr-iDQkSLXJ3t5ZIe';

  const isEstheticDentistry =
    clinicData?.id === 'CL_xngC2VcJ4U0zHMV4sHxKP' ||
    clinicData?.id === 'CL_ZpK-c22eNw6R71adpSPD7';

  const isChildrenDentistry =
    clinicData?.id === 'CL_9J7iQDycYMAvb6NpVb584' ||
    clinicData?.id === 'CL_36KEkPdDqQ_LZtk_Od8q7' ||
    clinicData?.id === 'CL_hbs44WQXfbYWliUYRXPVZ';

  const isNewSmileMasDental =
    clinicData?.id === 'CL_11hd8pBS2HQvaqamRKcRP' ||
    clinicData?.id === 'CL_TnrtZNSsBh46ADlTgUNDy';

  const isLuffOrthodonticsDental =
    clinicData?.id === 'CL_6fK1q4Y7infZ7TkZg3Ti5' ||
    clinicData?.id === 'CL_jUAIPjucnGWmf7NkjGpSL';

  const isCalKiddsDental =
    clinicData?.id === 'CL_Qvp9j9q_MtFnyh2aNlTnB' ||
    clinicData?.id === 'CL_yl_slXcm3N8jT_Im7kwn8' ||
    clinicData?.id === 'CL_BBEtN4exxr8yHweL-Xgtd' ||
    clinicData?.id === 'CL_xe7s2MPLiHs-Kuj462Gax' ||
    clinicData?.id === 'CL_4kj5crQt4xSywtIWAF7aa';

  return (
    <Drawer title="Scripts" isShowing={isShowing} setIsShowing={setIsShowing}>
      <div className="-mx-0.6 -my-0.5 flex flex-col gap-y-3.2">
        <div className="flex flex-col gap-y-1">
          <p className="font-bold">Scheduling button script</p>
          <div className="w-15">
            <ScriptSnippet
              isLoading={isLoading}
              url={`${process.env.REACT_APP_FIRSTIN_APP_URL}/static/js/widget.js?key=${data?.widgetKey}`}
              dataApp="first-in"
            />
          </div>
        </div>

        <div className="flex flex-col gap-y-1">
          <p className="font-bold">CTA button script</p>
          <div className="w-15">
            <ScriptSnippet
              isLoading={isLoading}
              url={`${process.env.REACT_APP_FIRSTIN_APP_URL}/static/js/customWidgetModal.js?key=${data?.widgetKey}`}
              dataApp="custom-script-first-in"
            />
          </div>
        </div>

        {isAppleTreeDental && (
          <div className="flex flex-col gap-y-1">
            <p className="font-bold">Multiple practice script</p>
            <div className="w-15">
              <ScriptSnippet
                isLoading={isAllLoading}
                url={`${process.env.REACT_APP_FIRSTIN_APP_URL}/static/js/selectPractice.js?key1=f693e1da-5d8d-45c9-9d7e-3b3c3811a5f1&key2=41f1a94c-9112-49a0-9add-760c613b9133`}
                dataApp="first-in"
              />
            </div>
          </div>
        )}

        {isSageDental && (
          <div className="flex flex-col gap-y-1">
            <p className="font-bold">Multiple practice script</p>
            <div className="w-15">
              <ScriptSnippet
                isLoading={isAllLoading}
                url={`${process.env.REACT_APP_FIRSTIN_APP_URL}/static/js/selectPractice.js?key1=88d31f15-4d1a-43a8-b366-a4cfc8b95c6f&key2=c6ea770d-2c91-4ae3-8958-b6de3eef276a`}
                dataApp="first-in"
              />
            </div>
          </div>
        )}

        {isOneDental && (
          <div className="flex flex-col gap-y-1">
            <p className="font-bold">Multiple practice script</p>
            <div className="w-15">
              <ScriptSnippet
                isLoading={isAllLoading}
                url={`${process.env.REACT_APP_FIRSTIN_APP_URL}/static/js/selectPractice.js?key1=d2958fbb-b4ec-440c-a88a-7d67ac606a75&key2=a27f7f73-38cf-4140-a0c8-520c0d91c384&key3=e316aa08-70f4-4af4-94ea-b71de5f62bd1`}
                dataApp="first-in"
              />
            </div>
          </div>
        )}

        {isSerenityDental && (
          <div className="flex flex-col gap-y-1">
            <p className="font-bold">Multiple practice script</p>
            <div className="w-15">
              <ScriptSnippet
                isLoading={isAllLoading}
                url={`${process.env.REACT_APP_FIRSTIN_APP_URL}/static/js/selectPractice.js?key1=d003ffaf-97d9-4b8c-ad0e-d15be5330954&key2=d3a38618-27be-477d-a862-3fdd17bcfa19`}
                dataApp="first-in"
              />
            </div>
          </div>
        )}

        {isSmileMasDental && (
          <div className="flex flex-col gap-y-1">
            <p className="font-bold">Multiple practice script</p>
            <div className="w-15">
              <ScriptSnippet
                isLoading={isAllLoading}
                url={`${process.env.REACT_APP_FIRSTIN_APP_URL}/static/js/selectPractice.js?key1=49b979b1-ac26-4abb-abab-51a26600a257&key2=518044c2-d773-4c75-9f49-681c88710884`}
                dataApp="first-in"
              />
            </div>
          </div>
        )}

        {isEstheticDentistry && (
          <div className="flex flex-col gap-y-1">
            <p className="font-bold">Multiple practice script</p>
            <div className="w-15">
              <ScriptSnippet
                isLoading={isAllLoading}
                url={`${process.env.REACT_APP_FIRSTIN_APP_URL}/static/js/selectPractice.js?key1=2207999a-b064-4460-94ee-2247aabe6d5b&key2=58272edb-b0fc-490b-982b-e6808e06697c`}
                dataApp="first-in"
              />
            </div>
          </div>
        )}

        {isChildrenDentistry && (
          <div className="flex flex-col gap-y-1">
            <p className="font-bold">Multiple practice script</p>
            <div className="w-15">
              <ScriptSnippet
                isLoading={isAllLoading}
                url={`${process.env.REACT_APP_FIRSTIN_APP_URL}/static/js/selectPractice.js?key1=6bcc13df-4064-4cf5-a36a-c3e491306808&key2=03ff4ad9-7e25-4df7-8063-345f41d8ed94&key3=1a9ebd5c-7040-4b41-bf09-55fa829d98f2`}
                dataApp="first-in"
              />
            </div>
          </div>
        )}

        {isNewSmileMasDental && (
          <div className="flex flex-col gap-y-1">
            <p className="font-bold">Multiple practice script</p>
            <div className="w-15">
              <ScriptSnippet
                isLoading={isAllLoading}
                url={`${process.env.REACT_APP_FIRSTIN_APP_URL}/static/js/selectPractice.js?key1=e02c00df-dada-4172-859d-c698dc18fa40&key2=c2c43e2a-7615-4c73-86c2-d0e713cd41b0`}
                dataApp="first-in"
              />
            </div>
          </div>
        )}

        {isLuffOrthodonticsDental && (
          <div className="flex flex-col gap-y-1">
            <p className="font-bold">Multiple practice script</p>
            <div className="w-15">
              <ScriptSnippet
                isLoading={isAllLoading}
                url={`${process.env.REACT_APP_FIRSTIN_APP_URL}/static/js/selectPractice.js?key1=96b2c372-d977-41dd-9db5-9d0fb2dbef6e&key2=b6148177-001c-4c10-8d38-c9a902584ac6`}
                dataApp="first-in"
              />
            </div>
          </div>
        )}

        {isCalKiddsDental && (
          <div className="flex flex-col gap-y-1">
            <p className="font-bold">Multiple practice script</p>
            <div className="w-15">
              <ScriptSnippet
                isLoading={isAllLoading}
                url={`${process.env.REACT_APP_FIRSTIN_APP_URL}/static/js/selectPractice.js?key1=ec177b46-c05f-4cad-956d-caad7fa6d350&key2=f0f81503-69b1-48bd-b9d5-1bc8946db7ed&key3=9e03a321-c313-4edf-8dec-e05caaeb066e&key4=19441f76-26ad-49e6-bf11-42a2ea56043f&key5=c860564a-27ce-47d0-be60-6153707528ba`}
                dataApp="first-in"
              />
            </div>
          </div>
        )}

        <div className="flex flex-col gap-y-1">
          <p className="font-bold">Scheduling button customization</p>
          <div className="w-15">
            <CustomizeScheduleButton />
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default ScriptDrawer;
